"use strict";
import {on, findAllIn, setAttribute, closest, findIn, addClass, removeClass} from "@elements/dom-utils";
import {update} from "./outlineGadgets";
import {getCoordinateValue} from "./outlineCoordinateParser";
import {scale} from "./outlineScaler";
import TerracePlanner from "../index";

export function init() {
    /**
     * initializes the module, binds event listeners
     */
    findAllIn('.js-planner__dimension-input', TerracePlanner.element).map((input) => {
        on('input', (evt) => {
            resizeListener(evt, input)
        }, input);

        on('change', () => {
            if (parseFloat(input.value) < parseFloat(input.getAttribute('min'))) {
                input.value = input.getAttribute('min');
            }
        }, input)

        on('blur', () => {
            hideError(input);
        }, input)
    });

    resizeListener(null);
}


/**
 * displays an error message in the validation group
 * @param input HTMLElement
 * @param message String
 */
function showError(input, message) {
    let validationGroup = closest('.js-form-validation__group', input);
    let errorContainer = findIn('.js-form-validation__errors', validationGroup);

    if (errorContainer) {
        errorContainer.innerText = message;
        addClass('is-invalid', input);
    }
}

/**
 * hides an error message in the validation group
 * @param input HTMLElement
 */
function hideError(input) {
    let validationGroup = closest('.js-form-validation__group', input);
    let errorContainer = findIn('.js-form-validation__errors', validationGroup);

    if (errorContainer) {
        errorContainer.innerText = '';
        removeClass('is-invalid', input);
    }
}

/**
 * parses a rectangle configuration and sets the resulting value to the actual DOM node inside the SVG
 * @see TerracePlanner.rectangleDimensions (comment) for the configuration's structure
 *
 * @param id String
 * @param rectangle
 */
function resize(id, rectangle) {
    let x = getCoordinateValue(rectangle.x);
    let y = getCoordinateValue(rectangle.y);
    let width = getCoordinateValue(rectangle.width);
    let height = getCoordinateValue(rectangle.height);

    let rect = document.getElementById(id);

    setAttribute('x', String(x), rect);
    setAttribute('y', String(y), rect);
    setAttribute('width', String(width), rect);
    setAttribute('height', String(height), rect);
}

/**
 * listener for applying new values to <rect/>s in an svg
 * also checks whether the input's value is below TerracePlanner.MAX_SIDE_LENGTH
 *
 * @param evt Event
 */

function resizeListener (evt, input) {
    if(null !== evt) {
        if (parseFloat(input.value) > TerracePlanner.MAX_SIDE_LENGTH) {
            input.value = input.getAttribute('data-previous-value');
            evt.preventDefault();
            evt.stopImmediatePropagation();

            showError(input, input.getAttribute('data-error-message-max'));
            return;
        }

        if (parseFloat(input.value) < parseFloat(input.getAttribute('min'))) {
            showError(input, input.getAttribute('data-error-message-min'));

            return;
        }

        hideError(input);
        setAttribute('data-previous-value', input.value, input);
    }

    let config = TerracePlanner.rectangleDimensions;

    for (let rectangleId in config) {
        if (! config.hasOwnProperty(rectangleId)) {continue;}

        resize(rectangleId, config[rectangleId]);
    }

    scale();
    update(TerracePlanner.dimensionLetters);
    update(TerracePlanner.directionButtons);
}